/** Sidebar credits meter + upgrade card (OutlierOS UsageMeter / free-plan card). Numbers come from /api/credits. */
import { cn } from '../cn';

/** `resetsOn` is the formatted end of the account's credit period (its billing date, decision 85). */
export function UsageMeter({ used, limit, href, onNavigate, upgradeHint, resetsOn }: { used: number; limit: number; href: string; onNavigate: (h: string) => void; upgradeHint: boolean; resetsOn?: string }) {
  const pct = limit > 0 ? Math.min(100, Math.round((used / limit) * 100)) : 100;
  const bar = pct >= 100 ? 'bg-red-500' : pct >= 80 ? 'bg-amber-500' : 'bg-primary';
  const resets = resetsOn ? `Resets on ${resetsOn}.` : 'Resets on your billing date.';
  return (
    <a href={href} onClick={(e) => { e.preventDefault(); onNavigate(href); }} title={`Transcription credits this billing period. ${resets} Longer reels use more credits.`}
      className="block rounded-xl border border-border bg-card px-3 py-2.5 text-xs hover:bg-secondary/60">
      <div className="flex items-center justify-between font-semibold"><span>Transcription</span><span className="tabular-nums text-muted-foreground">{used} / {limit} credits</span></div>
      <div className="mt-2 h-1.5 overflow-hidden rounded-full bg-secondary"><div className={cn('h-full rounded-full', bar)} style={{ width: `${pct}%` }} /></div>
      {pct >= 80
        ? <p className="mt-1.5 text-[11px] text-muted-foreground">{pct >= 100 ? 'Limit reached.' : 'Running low.'} {upgradeHint ? <span className="font-semibold text-primary">Upgrade for more →</span> : resets}</p>
        : resetsOn && <p className="mt-1.5 text-[11px] text-muted-foreground">{resets}</p>}
    </a>
  );
}

export function UpgradeCard({ planName, href, onNavigate }: { planName: string; href: string; onNavigate: (h: string) => void }) {
  return (
    <a href={href} onClick={(e) => { e.preventDefault(); onNavigate(href); }} className="block rounded-xl border border-primary/20 bg-primary/5 px-3 py-2.5 text-xs">
      <div className="font-semibold">{planName} plan</div>
      <div className="mt-0.5 text-primary">Upgrade for more scans and transcription credits →</div>
    </a>
  );
}
